module.exports = __webpack_public_path__ + "static/img/v2_qnqllr.c10bab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/my/v2_qnqllr.png
// module id = Uw7i
// module chunks = 1